export default __webpack_public_path__ + "static/media/app_store_badge.85cd7208.png";